<template> 
  <div style="text-align: center; margin-top: 12px; position: relative;" class="">
    <Loader v-if="getPartLoading == true" />  
    <a v-if="generalValues && generalValues[0]" target="_blank" :href="'https://amazon.com/dp/'+generalValues[0]"><button style="width: 200px;" class="gc-button">Amazon link</button></a>
    <!-- <div v-if="getSavedForm && getSavedForm.item !=='' && getSavedForm.type == 'undefined' && recovered == false && cleared == false" class="notification">
      <span>The form has some saved data with invalid type</span>
      <div class="notification-options">
        <a @click="loadSavedForm('undefined')">Recover</a>
        <a @click="clearSavedForm('undefined'), clearedTrue()">Clear</a> -->
        <!-- <a @click="saveForm()">Save</a>
        <a @click="showLocalStorage()">Show localStorage</a> -->
      <!-- </div>
    </div> -->
    <!-- <a @click="testData()">Test Data</a> -->
    <!-- <div @click="getAttribsList()">getAttribsList</div>
    <div @click="show()">show</div> -->
    <!-- <div v-if="getSavedForm && getSavedForm.item !=='' && getSavedForm.type == getType() && recovered == false && cleared == false" class="notification">
      <span>The form has some saved data with valid type {{getType()}}</span>
      <div class="notification-options">
        <a @click="loadSavedForm(getType())">Recover</a>
        <a @click="clearSavedForm(getType()), clearedTrue()">Clear</a>
      </div>
    </div> -->
    <!-- Form -->
    <div style="float: right; margin-top: -42px; padding-right: 15px;">
      <a class="nav-button" style="margin: 0px" @click="handleProcessorSubmit({clone: true})">Clone</a>

    </div>
    <div class="form" >
      <form class="main-frame1" v-on:submit.prevent='handleProcessorSubmit({clone: false})'>
        <fieldset class="fieldset edit">
          <div class="">
            <!-- IMPORT SECTION -->
            <!-- <div v-if="!checkEdit()" class="top-block block">
              <div class="label">
                <br>
                <h4>Import</h4>
              </div>
              <input 
                style="display:inline-block;" 
                class="form-control url-input" 
                v-model="url"
                placeholder="ASIN"
                >
              <button type="button" v-if="this.fetchingAmzn == false" @click="fetchProductInfo(url)" style="display:inline-block; margin-left: 10px;" class="gc-button">
                FETCH
              </button>
              <button type="button" v-if="this.fetchingAmzn == true" style="display:inline-block; margin-left: 10px;" class="gc-button">
                FETCHING...
              </button>
            </div> -->
            <!-- IMAGES -->
            <div class="block">
              <h4>Images</h4>
              <div v-if="this.images && this.images.length == 0 && this.images!=='N/A'">
                <div @click="imgInputFocus()" class="img-div img-empty">
                  <a style="color: #9198aa" class="plus">+</a>
                </div>
              </div>
              <div v-if="this.images.length > 0 && this.images!=='N/A'">
                <div v-for="(img, index) in images" 
                  :key="index" 
                  class="img-div img-not-empty"
                  style="position: relative"
                  :style="{backgroundImage: 'url(' + img + ')'}"
                  >
                  <a @click="spliceImg(index)" class="cross">X</a>
                  <a v-if="index !== 0" @click="makeMain(images, index)" style="text-align: center; bottom: 0px; right: 0px;left:0px; position: absolute" class="cross make-main-button">make main</a>
                </div>
              </div>
              <div class="images">
                <input type="text" 
                  id="imgInput"
                  ref="imgInput"
                  v-model="imgUrl"
                  style="display: inline-block;"
                  class="form-control url-input" 
                  placeholder="Paste URL"
                  >
                  <button type="button" @click="addImg(imgUrl)" style="display: inline-block; margin-left: 10px;" class="gc-button"><li>ADD</li></button>
              </div>
            </div>
            <!-- Bullets -->
            <div class="block">
              <h4>Bullet Points</h4>
              <div v-if="this.bullets.length > 0">
                <ul v-for="(bullet, index) in bullets" 
                  :key="index" 
                  style="list-style-type: circle !important; padding-left: 10px;"
                  class="bullets"
                  >
                  <li>{{bullet}} <a @click="spliceBullet(index)" class="cross">X</a></li>
                </ul>
              </div>            
              <div class="images">
                <input type="text" 
                  ref="bulletInput"
                  v-model="bullet"
                  style="display: inline-block;"
                  class="form-control url-input" 
                  placeholder="Add Bullet Point"
                  >
                  <button @click="addBullet(bullet)" type="button" style="display: inline-block; margin-left: 10px;" class="gc-button"><li>ADD</li></button>
              </div>
            </div>
            <!-- GENERAL IMFORMATION -->
            <div class="block">
             
              <h4>{{getType()}} General Informaion</h4>
                <div class="form-group " v-for="(field, index) in forms.attribs.general" :key="index">
                    <label @click="showAsin()" for="forms">{{field}}</label>
                    <select v-if="dropdown(getType(), field).length >0 && field !== 'type'" v-model="generalValues[index]" 
                        :name="field" :id="generalValues[index]"
                        class="form-control form-80-percent-width" 
                        :ref='"input_general_"+field'
                      >
                      <option v-for="(option, optIndex) in dropdown(getType(), field)" :key="optIndex" :value="option">{{option}}</option>
                    </select>
                    <input 
                      v-if="field == 'type'"
                      :ref='"input_general_"+field'
                      v-model="type" 
                      :type="form" 
                      class="form-control form-80-percent-width" 
                      :id="generalValues[index]"
                      :placeholder="message"
                    >
                    <input 
                      v-else
                      :ref='"input_general_"+field'
                      v-model="generalValues[index]"
                      :type="form" 
                      class="form-control form-80-percent-width" 
                      :id="generalValues[index]"
                      :placeholder="message"
                    >
                </div>
              </div>
            </div>
          <!-- Specifications -->
          <div class="block">
            <h4>{{this.category}} Specifications</h4>
            <div class="form-group " v-for="(field, index1) in forms.attribs.specifications" :key="index1">
              <label @click="showAsin()" for="forms">{{field}}</label>
              <select v-if="dropdown(getType(), field).length >0" v-model="specValues[index1]"
                        :name="field" :id="specValues[index1]"
                        class="form-control form-80-percent-width" 
                        :ref='"input_specs_"+field'
                      >
                <option v-for="(option, optIndex) in dropdown(getType(), field)" :key="optIndex" :value="option">{{option}}</option>
              </select>
              <input
                v-else
                :ref='"input_specs_"+field'
                v-model="specValues[index1]"
                :type="form" 
                class="form-control form-80-percent-width" 
                :id="specValues[index1]"
                :placeholder="message"
              >
            </div>
          </div>
          <!-- Compatibilities -->
          <div class="block">
            <h4>{{this.category}} Compatibilities</h4>
            <div class="form-group " v-for="(field, index2) in forms.attribs.compats" :key="index2">
              <label @click="showAsin()" for="forms">{{field}}</label>
              <select v-if="dropdown(getType(), field).length >0" v-model="compatsValues[index2]" 
                        :name="field" :id="generalValues[index]"
                        class="form-control form-80-percent-width" 
                        :ref='"input_compats_"+field'
                      >
                <option v-for="(option, optIndex) in dropdown(getType(), field)" :key="optIndex" :value="option">{{option}}</option>
              </select>
              <input 
              v-else
                :ref='"input_compats_"+field'
                v-model="compatsValues[index2]"
                :type="form" 
                class="form-control form-80-percent-width" 
                :id="compatsValues[index2]"
                :placeholder="message"
              >
            </div>
          </div>
            <button type="submit" class="gc-button submit-button">Submit</button>
        </fieldset>
      </form>
       <!-- {{$refs['input_general_asin'][0].value}} -->
    </div>
  </div>  
</template>

<script>
import { mapGetters, mapActions }   from 'vuex';
import Loader                       from '../widgets/loader.vue'
import _                            from 'lodash'
import axios                        from 'axios'
import {SERVER_PATH}                from '../../config'

export default {
  name: 'Add Part',
  components:{
    Loader
  },
  watch: { 
        values(n) { // watch it
          console.log('values changed')
        },
        asin: function(newVal) { // watch it
          console.log(newVal)
        },
        forms(n){
          console.log('form was updated')
        }
    },
  data() {
    return {
      cleared: false,
      fetchingAmzn: false,
      recovered: false,
      images: [],
      bullets: [],
      bullet: '',
      type: '123',
      status: 'Paste a product link and press fetch to get started...',
      forms: {},
      generalValues:  [],
      specValues:     [],
      compatsValues:   [],
      categoryChosen: false,
      category: '',
      message: '',
    }
  },
  computed: {
    getSavedForm(){
      if(localStorage['savedundefinedForm'] && localStorage['savedundefinedForm'] !== '' ){
        return {type: 'undefined', item: localStorage['savedundefinedForm']}
      }
      if(localStorage['saved'+this.getType()+'Form'] && localStorage['saved'+this.getType()+'Form'] !== '') {
        return {type: this.getType(), item: localStorage['saved'+this.getType()+'Form'] }
      }
      else return ''
      
    },
    ...mapGetters([
          'getPartLoading',
          'getMessage',
          'getAttribs',
          'getItem',
          'getItemLoaded'
        ]),
  },
  mounted() {
    if(this.checkEdit()){
      if(this.getItem){
       this.images = JSON.parse(this.getItem.imgUrl)
       this.bullets = JSON.parse(this.getItem.bullets)
      }

    }
  },
  methods: {
    ...mapActions([
      'setPartAttribs',
      'clearSavedForm'
    ]),
    prepareModel(type, index){
      if(type == 'general'){
        this.generalValues[index] = ''
      }
      return

    },
    clearedTrue(){
      this.cleared = true
    },
    dropdown(type, field){
      var result = []
      var storageDropdowns = 
        {
          'Disk_Type':  ['HDD', 'SSD'],
          'size':       ['3.5', '2.5', 'M.2'],
          'compat_interface': ['PCI-E', 'SATA'],
          'hardware_interface': ['PCI-E', 'SATA'],
          
        }
      
      if(type == 'storage'){
        // console.log('checking field ', Object.keys(storageDropdowns) )
        if(Object.keys(storageDropdowns).includes(field)){
          result = storageDropdowns[field]
        }
      }
      // console.log("DROPDOWN RESULT", result, ' for type ', type)
      return result
    },
    scrollToTop() {
      window.scrollTo(0,0);
    },
    loadSavedForm(type){
      console.log("Load started with type: ", type)
      var savedItemForm = 'saved'+type+'Form'
      var savedData
      if(localStorage && localStorage[savedItemForm] && localStorage[savedItemForm] !== ''){
        console.log("found saved ", type, localStorage[savedItemForm])
        savedData = JSON.parse(localStorage[savedItemForm])
        console.log('prepared saved data ', savedData)
        var fieldNames = _.cloneDeep(this.getAttribs)
        console.log("prepared fieldNames ", fieldNames)
        var savedDataKeys = Object.keys(savedData)
        console.log("prepared saved data field names list ", savedDataKeys)
        if(savedDataKeys.length > 1){
          // Parsing from JSON 
          if(savedDataKeys.includes('imgUrl')){
            if(typeof(savedData.imgUrl) == 'string'){
              savedData.imgUrl = JSON.parse(savedData.imgUrl)
            }
            this.images = savedData.imgUrl
          }
          if(savedDataKeys.includes('bullets')){
            if(typeof(savedData.bullets) == 'string'){
              savedData.bullets = JSON.parse(savedData.bullets)
            }
            this.bullets = savedData.bullets
          }
          savedDataKeys.map(item => {
            console.log("FORMS HERE ", this.forms)
            console.log("if " + fieldNames.general + "includes ", item)
            if(fieldNames.general.includes(item)){
              
              for(let i = 0; i< this.forms.attribs.general.length; i++){
                if(this.forms.attribs.general[i].includes(item)){
                  this.generalValues[i] = savedData[item]
                  // console.log('added to general values ', savedData[item])
                }
              }
            }
            if(fieldNames.specifications.includes(item.replace(/_/gi, ' '))){
              for(let i = 0; i< this.forms.attribs.specifications.length; i++){
                if(this.forms.attribs.specifications[i].includes(item.replace(/_/gi, ' '))){
                  this.specValues[i] = savedData[item]
                  // console.log('added to spec values ', savedData[item])
                }
              }
            }
            if(fieldNames.compats.includes(item)){
              for(let i = 0; i< this.forms.attribs.compats.length; i++){
                if(this.forms.attribs.compats[i].includes(item)){
                  this.compatsValues[i] = savedData[item]
                  // console.log('added to compat values ', this.compatsValues[i])
                }
              }
            }
          })
        }
      }
      this.recovered = true
      console.log("RECOVERED VALUES: ", this.generalValues, this.specValues, this.compatsValues)
    },
    showLocalStorage(){
      console.log(localStorage)
    },
    updateRefField(field, value){
      this.$refs[field][0].value = value
      console.log("field ", field)
      console.log("value ", value)
    },
    testData(){
          localStorage.setItem('savedundefinedForm', `
      {
        "type": "undefined",
        "item": {
          "imgUrl": [
            "https://m.media-amazon.com/images/I/91MFwJy3syL._AC_SX450_.jpg",
            "https://m.media-amazon.com/images/I/91MFwJy3syL._AC_SL1500_.jpg",
            "https://m.media-amazon.com/images/I/911RlXmIDXL._AC_SL1500_.jpg",
            "https://m.media-amazon.com/images/I/91XOd0Dt6dL._AC_SL1500_.jpg",
            "https://m.media-amazon.com/images/I/91XPiIhnQ9L._AC_SL1500_.jpg",
            "https://m.media-amazon.com/images/I/91PcyFusP5L._AC_SL1500_.jpg",
            "https://m.media-amazon.com/images/I/91SEak+i+2L._AC_SL1500_.jpg",
            "https://m.media-amazon.com/images/I/81fGYlFQ1DL._AC_SL1500_.jpg",
            "https://m.media-amazon.com/images/I/A1rssquyn5L._AC_SL1500_.jpg",
            "https://m.media-amazon.com/images/I/91VVTruXnDL._AC_SL1500_.jpg",
            "https://m.media-amazon.com/images/I/91Es-c5x9fL._AC_SL1500_.jpg",
            "https://m.media-amazon.com/images/I/91YLvcQOJML._AC_SL1500_.jpg"
          ],
          "bullets": [
            "Supports 11th and 10th Gen Intel Core/Pentium/Celeron processors for LGA 1200 Socket",
            "Supports DDR4 Memory, up to 5333(OC) MHz",
            "Lightning Fast Game experience: PCIe 4.0, Lightning Gen 4 x4 M.2, USB 3.2 Gen 2x2",
            "Enhanced Power Design: 16+1+1 Duet Rail Power System, dual 8-pin CPU power connectors, Core Boost, DDR4 Boost",
            "Premium Thermal Solution: Enlarged heatsink with heat-pipe, MOSFET thermal pads rated for 7W/mk, additional choke thermal pads and 3x M.2 Shield Frozr are built for high performance system and non-stop gaming experience"
          ],
          "asin": "B08WBW8DB7",
          "type": "motherboard",
          "brand": "MSI",
          "model": "MPG Z590 Gaming Carbon WiFi",
          "description": "MSI MPG Z590 Gaming Carbon WiFi Gaming Motherboard (ATX, 11th/10th Gen Intel Core, LGA 1200 Socket, DDR4, PCIe 4, CFX, M.2 Slots, USB 3.2 Gen 2, Wi-Fi 6E, DP/HDMI, Mystic Light RGB)",
          "form_factor": "ATX",
          "amzn_price": "$269.99",
          "Compatible_Memory": "DDR4",
          "Socket": "LGA 1200",
          "WiFi": "Yes",
          "Integrated_Graphics": "Yes",
          "USB": "3.2",
          "Max_Memory_Size": "128",
          "ECC_Support": "Yes",
          "processor_generation": "10 11",
          "socket": "LGA 1200",
          "m_2": "PCI/SATA",
          "M_2_Slot": "3",
          "ram": "DDR4",
          "ram_speed": "3200 MHz",
          "ram_slots": "4",
          "pci_e": "4.0",
          "sata_slots": "6",
          "sata_speed": "6Gb/s",
          "pci_e_slots": "3",
          "tdp": "55",
          "nvme": "PCI/SATA",
          "pci_e_x1": "2",
          "pci_e_x4": "0",
          "pci_e_x8": "0",
          "pci_e_x16": "3",
          "cpu_brand": "Intel"
        }
      }
    `)
    },
    getType(){
      this.type = this.$route.query.type
      return this.$route.query.type
    },
    saveForm(){
      var attribs = {}
      attribs.general = this.generalValues
      attribs.specifications = this.specValues
      attribs.compats = this.compatsValues
      var type = this.getType()
      if(attribs.general){
        console.log('saving form ', attribs.general)
        attribs.general["imgUrl"] = JSON.stringify(this.images)
        attribs.general["bullets"] = JSON.stringify(this.bullets)
        if(this.$route.name == 'Edit Part'){
          attribs.general["id"] = this.getItem.id
        }
        for(var i = 0; i< this.forms.attribs.general.length; i++){
          attribs.general[this.forms.attribs.general[i].replace(/ |-/gi, '_')] = attribs.general[i]
          delete attribs.general[i]
        }
        for(var j = 0; j< this.forms.attribs.specifications.length; j++){
          attribs.specifications[this.forms.attribs.specifications[j].replace(/ |-/gi, '_')] = attribs.specifications[j]
          delete attribs.specifications[j]
        }
        for(var k = 0; k< this.forms.attribs.compats.length; k++){
          attribs.compats[this.forms.attribs.compats[k].replace(/ |-/gi, '_')] = attribs.compats[k]
          delete attribs.compats[k]
        }
        var fullAttribs = {
          ...attribs.general,
          ...attribs.specifications,
          ...attribs.compats
        }
          var savedFormName = 'saved'+this.getType()+'Form'
          localStorage.setItem(savedFormName, JSON.stringify(fullAttribs))
          console.log('item form was saved ', localStorage)
        return 
      }
    },
    makeMain(images, index){
      if(images && index){
        var tmpImages = [...images]
        var mainImage = images[index]
        tmpImages.splice([index], 1)
        tmpImages.unshift(mainImage)
        this.images = [...tmpImages]
        console.log(this.images)
        console.log('made main')
      }
    },
    spliceImg(index){
      this.images.splice(index, 1)
      console.log('spliced array', "index removed:", index,"  ", this.images)
    },
    spliceBullet(index){
      this.bullets.splice(index, 1)
      console.log('spliced array', "index removed:", index,"  ", this.bullets)
    },
    imgInputFocus(){
      this.$refs.imgInput.focus()
    },
    bulletInputFocus(){
      this.$refs.bulletInput.focus()
    },
    addImg(imgUrl){
      if(imgUrl !== undefined && imgUrl.length > 3) {
        this.images.push(imgUrl)
        console.log('url added to array:', this.images)
        this.imgUrl = undefined
        this.$refs.imgInput.value = ''
      }
      else console.log('bad url')
      this.imgUrl = undefined
    },
    addBullet(bullet){
      if(bullet !== undefined && bullet.length > 3) {
        this.bullets.push(bullet)
        console.log('bullet added to array:', this.bullets)
        this.bullet = undefined
        this.$refs.bulletInput.value = ''
        this.bulletInputFocus()
      }
      else console.log('bad url')
      this.bullet = undefined
    },
    checkEdit(){
      if(this.$route.name == 'Edit Part'){
        return true
      }
      else return false
    },
    show(){
      console.log('generalValues: ', this.generalValues)
      console.log('specValues: ', this.specValues)
      console.log('compatsValues: ', this.compatsValues)
    },
    getAttribsList(){
      console.log('generalValues: ', this.generalValues)
      console.log('specValues: ', this.specValues)
      console.log('compatsValues: ', this.compatsValues)
      var attribs = {}
      attribs.general = {...this.generalValues}
      attribs.specifications = {...this.specValues}
      attribs.compats = {...this.compatsValues}
      if(attribs.general){
        console.log('getattribs values', this.generalValues, this.specValues, this.compatsValues)
        // console.log("ATTRIBS ", attribs)
        // console.log('THIS.FORMS ', this.forms)
        for(var i = 0; i< this.forms.attribs.general.length; i++){
          // console.log("this.forms.attribs.general[i] ", this.forms.attribs.general[i])
          var formField = this.forms.attribs.general[i].replace(/ |-/gi, '_')
          // console.log("FORM FIELD MATCH ", formField, attribs.general)
          attribs.general[formField] = attribs.general[i]
          delete attribs.general[i]
          this.updateRefField(
            "input_general_"+ formField,
            attribs.general[formField]
          )
          // console.log("CHECKING HERE ", attribs.general)
        }
        for(var j = 0; j< this.forms.attribs.specifications.length; j++){
          // console.log('assigning form field to attribs.specifications', this.forms.attribs.specifications[j])
          attribs.specifications[this.forms.attribs.specifications[j].replace(/ |-/gi, '_')] = attribs.specifications[j] || ''
          delete attribs.specifications[j]
        }
        for(var k = 0; k< this.forms.attribs.compats.length; k++){
          attribs.compats[this.forms.attribs.compats[k]] = attribs.compats[k]
          delete attribs.compats[k]
        }
        if(this.$route.name == 'Edit Part'){
          attribs.general["id"] = this.getItem.id
        }
        attribs.general["imgUrl"] = JSON.stringify(this.images)
        attribs.general["bullets"] = JSON.stringify(this.bullets)
        attribs.general["type"] = this.getType()
        // console.log("ATTRIBS READY ", attribs)
        var fullAttribs = {
          ...attribs.general,
          ...attribs.specifications,
          ...attribs.compats
        }
        // console.log("ASSIGN REFS")
        //         // GENERAL
        // for(const field in attribs.general){
        //   for (const ref in this.$refs){
        //     if(ref.toLowerCase().replace(/ |-/gi, '_').toLowerCase().includes(field.toLowerCase()) && field !== 'specs' && field !== 'compat'){
        //       if( this.$refs[ref][0]){
        //         this.$refs[ref][0].value = attribs.general[field.replace(/ |-/gi, '_')]
        //       }
        //       this.forms.attribs.general[field.replace(/ |-/gi, '_')] = attribs.general[field.replace(/ |-/gi, '_')]
        //       // console.log('general asigning value to field ', this.$refs[ref][0])
        //     }
        //   }
        // }
        // // SPECS
        // for(const field in attribs.specifications){
        //   // console.log('assigning specs ', field)
        //   for (const ref in this.$refs){
        //     if(ref.toLowerCase().replace(/ |-/gi, '_').toLowerCase().includes(field.replace(/ |-/gi, '_').toLowerCase()) && !field.includes('specs')){
        //       console.log('match found, value ', attribs.specifications[field.replace(/ |-/gi, '_')])
        //       if( this.$refs[ref][0]){
        //         this.$refs[ref][0].value = attribs.specifications[field.replace(/ |-/gi, '_')]
        //       }
        //       this.forms.attribs.specifications[field.replace(/ |-/gi, '_')] = attribs.specifications[field.replace(/ |-/gi, '_')]
        //       // console.log('specifications asigned value to field ', this.$refs[ref][0].value,  this.forms.attribs.specifications[field.replace(/ |-/gi, '_')])
        //     }
        //   }
        // }
        // //COMPATS
        // for(const field in attribs.compats){
        //   for (const ref in this.$refs){
        //     if(ref.toLowerCase().replace(/ |-/gi, '_').toLowerCase().includes(field.replace(/ |-/gi, '_').toLowerCase()) && !field.includes('compat')){
        //       if( this.$refs[ref][0]){
        //         this.$refs[ref][0].value = attribs.compats.compat[field.replace(/ |-/gi, '_')]
        //       }
        //       this.forms.attribs.compats[field.replace(/ |-/gi, '_')] = attribs.compats[field.replace(/ |-/gi, '_')]
        //       if(ref.includes('tdp') && !field.includes('compat')){
        //         console.log("tdp!!! ", field.replace(/ |-/gi, '_'), ' field: ', field)
        //       }
        //       // console.log('compats asigning value to field ', this.$refs[ref][0].value)
        //     }
        //   }
        // }
        // this.$forceUpdate()



        console.log('returning full attribs ', fullAttribs)

        return JSON.stringify(fullAttribs)
      }
    },
    async fetchProductInfo(asin){
      console.log('refs ', this.$refs)
      console.log('this.forms ', this.forms)
      console.log('values ', this.generalValues, this.specValues, this.compatsValues)
      this.fetchingAmzn = true
      var productData = null
      await axios({
        method: 'GET',
        url: `${SERVER_PATH}scrape/product?asin=${asin}`
      }).then((response) => {productData = response; this.fetchingAmzn = false})
      .catch((error) => {console.log(error); this.fetchingAmzn = false})
      console.log('fetched amazon data: ', productData)
      if(productData.data.mainImg && productData.data.mainImg !== 'could not catch'){
        this.images.push(productData.data.mainImg)
      }
      if(productData.data.bullets && productData.data.bullets !== 'could not catch' && productData.data.bullets.length >0){
        productData.data.bullets.map(item => {
          this.bullets.push(item)
        })
      }
      for(var i = 0; i< this.forms.attribs.general.length; i++){
        if(this.forms.attribs.general[i] == 'amzn_price'){
           this.generalValues[i] = productData.data.price
        }
        if(this.forms.attribs.general[i] == 'description'){
           this.generalValues[i] = productData.data.title
        }
        if(this.forms.attribs.general[i] == 'asin'){
           this.generalValues[i] = productData.data.asin
        }
        if(this.forms.attribs.general[i] == 'type'){
          console.log('type ', this.getType())
           this.generalValues[i] = this.getType()
        }
        if(this.forms.attribs.general[i] == 'brand'){
           this.generalValues[i] = productData.data.brand
        }
      }
      for(var j = 0; i<this.forms.attribs.specifications.length; i++){
        if(this.forms.attribs.specifications[j] == 'brand'){
          this.specValues[j] = productData.data.brand
        }        
      }
      for(var k = 0; k<this.forms.attribs.compats.length; k++){
        if(this.forms.attribs.compats[k] == 'brand'){
          this.compatsValues[k] = productData.data.brand
        }
      }
      console.log(this.$refs)
      for (const ref in this.$refs){
        if(ref.toLowerCase().includes('price')){
          this.$refs[ref][0].value = productData.data.price
        }
        if(ref.toLowerCase().includes('description')){
          this.$refs[ref][0].value = productData.data.title
        }
        if(ref.toLowerCase().includes('asin')){
          this.$refs[ref][0].value = productData.data.asin
        }
        if(ref.toLowerCase().includes('type')){
          this.$refs[ref][0].value = this.getType()
        }
        if(ref.toLowerCase().includes('brand')){
          console.log('ref brand ', this.$refs[ref])
          this.$refs[ref][0].value = productData.data.brand
        }
        // if(ref.toLowerCase().includes('cpu_brand')){
        //   if(productData.data.title.toLowerCase().includes('intel')){
        //     this.$refs[ref][0].value = 'Intel'
        //   }
        //   else if(productData.data.title.toLowerCase().includes('amd')){
        //     this.$refs[ref][0].value = 'AMD'
        //   }
        // }
      }
      console.log('refs ', this.$refs)
      console.log('this.forms ', this.forms)
      console.log('fetched product price: ', productData.data.price)
    },
    showAsin(){
      // if(this.generalValues)
      // console.log(this.generalValues[0])
    },
    print(index){
      return console.log(Object.values(this.settings.options)[index])
    },
    async handleProcessorSubmit({clone}) {
      var cloneMode = false
      if(clone == true){
        cloneMode = true
      }
      this.scrollToTop()
      // if(this.$route.name == 'Add Part'){
      //   this.saveForm()
      // }
			const postData = this.getAttribsList()
      var savedFormName = 'saved'+this.getType()+'Form'
      localStorage.setItem(savedFormName, JSON.stringify(postData))
      // Sending Request
      console.log('sending this')
      console.log(postData)
      if(this.$route.name == 'Add Part'){
        try{
          await this.$store.dispatch('addItem', JSON.parse(postData))
        }catch(e){
          console.log("Error: ")
          console.log(e)
        }
      }
      if(this.$route.name == 'Edit Part' && cloneMode == false){
        try{
          await this.$store.dispatch('editItem', postData)
        }catch(e){
          console.log("Error: ")
          console.log(e)
        }
      }
      if(this.$route.name == 'Edit Part' && cloneMode == true){
        try{
          var tempData = JSON.parse(postData)
          tempData.asin = 'CLONE '+tempData.asin
          tempData.description = 'CLONE '+tempData.description
          tempData.brand = 'CLONE '+tempData.brand
          JSON.parse(postData).asin = 'CLONE'
          await this.$store.dispatch('addItem', tempData)
        }catch(e){
          console.log("Error: ")
          console.log(e)
        }
      }
    },
    assignInput(){
      if(this.$route.name == "Edit Part") {
        console.log('input fields assign started....')
        // GENERAL
        for(var i =0; i<this.forms.attribs.general.length; i++){
          this.generalValues[i]          = this.getItem[this.forms.attribs.general[i].replace(/ |-/gi, '_')]
          // console.log('general arrtib assigned ', this.generalValues[i])
        }
        // SPECS
        for(var j =0; j<this.forms.attribs.specifications.length; j++){
          this.specValues[j]   = this.getItem.specs[this.forms.attribs.specifications[j].replace(/ |-/gi, '_')]
          // console.log('specifications arrtib assigned ', this.specValues[j])
        }
        //COMPATS
        for(var k =0; k<this.forms.attribs.compats.length; k++){
          this.compatsValues[k]          = this.getItem.compat[this.forms.attribs.compats[k].replace(/ |-/gi, '_')]
          // console.log('compats arrtib assigned ', this.compatsValues[k])
          
        }
        // GENERAL
        for(const field in this.getItem){
          for (const ref in this.$refs){
            if(ref.toLowerCase().replace(/ |-/gi, '_').toLowerCase().includes(field.toLowerCase()) && field !== 'specs' && field !== 'compat'){
              if( this.$refs[ref][0]){
                this.$refs[ref][0].value = this.getItem[field.replace(/ |-/gi, '_')]
              }
              this.forms.attribs.general[field.replace(/ |-/gi, '_')] = this.getItem[field.replace(/ |-/gi, '_')]
              // console.log('general asigning value to field ', this.$refs[ref][0])
            }
          }
        }
        // SPECS
        for(const field in this.getItem.specs){
          // console.log('assigning specs ', field)
          for (const ref in this.$refs){
            if(ref.toLowerCase().replace(/ |-/gi, '_').toLowerCase().includes(field.replace(/ |-/gi, '_').toLowerCase()) && !field.includes('specs')){
              // console.log('match found, value ', this.getItem.specs[field.replace(/ |-/gi, '_')])
              if( this.$refs[ref][0]){
                this.$refs[ref][0].value = this.getItem.specs[field.replace(/ |-/gi, '_')]
              }
              this.forms.attribs.specifications[field.replace(/ |-/gi, '_')] = this.getItem.specs[field.replace(/ |-/gi, '_')]
              // console.log('specifications asigned value to field ', this.$refs[ref][0].value,  this.forms.attribs.specifications[field.replace(/ |-/gi, '_')])
            }
          }
        }
        //COMPATS
        for(const field in this.getItem.compat){
          for (const ref in this.$refs){
            if(ref.toLowerCase().replace(/ |-/gi, '_').toLowerCase().includes(field.replace(/ |-/gi, '_').toLowerCase()) && !field.includes('compat')){
              if( this.$refs[ref][0]){
                this.$refs[ref][0].value = this.getItem.compat[field.replace(/ |-/gi, '_')]
              }
              this.forms.attribs.compats[field.replace(/ |-/gi, '_')] = this.getItem.compat[field.replace(/ |-/gi, '_')]
              if(ref.includes('tdp') && !field.includes('compat')){
                console.log("tdp!!! ", field.replace(/ |-/gi, '_'), ' field: ', field)
              }
              // console.log('compats asigning value to field ', this.$refs[ref][0].value)
            }
          }
        }
        this.$forceUpdate()
      }
      else {
        return
      }
    }
  },
  beforeMount(){
    this.forms.attribs = this.getAttribs;
  },
  updated(){
  },
  created(){
    this.type = this.getType()
    console.log(this.$route.name)
    if(this.getItemLoaded){
      setTimeout(
      () => {
        if(this.$route.name =='Edit Part'){
          this.assignInput()
        }
        else {
          this.images = []
          this.bullets = []
          this.generalValues = []
          this.specValues = []
          this.compatsValues = []
          console.log(this.$refs)
          // this.$refs['input_general_type'][0].value = this.getType()
        }
      }, 1500);
    }
  }
}
</script>
<style scoped>
h4 {
  margin-bottom: 15px;
  color: white !important;
  text-transform: capitalize;
  text-align: left;
  padding-left: 20px;
}
.img-div {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  height: 120px;
  width: 120px;
  border: 1px solid #434857;
  border-radius: 6px;
  margin: 15px;
  margin-bottom: 25px;
  display: inline-block;
  background-color: white;
}
.img-div .img-empty {
  text-align: center;
}
.img-not-empty {
  text-align: right;
    background-color: white;
}
.images {
  margin: 0px !important;
  display: flex;
  padding-left: 22px;
  padding-right: 22px;
}
.menu-component {
  min-height: 690px;
}
.img-div:hover {
  border: 1px solid #1997c6;
  cursor: pointer;
}
.img-div .img-empty:hover {
  color: #1997c6 !important;
}
.img-div.img-empty:hover a {
  color: #1997c6 !important;
}
.main-frame1 {
  overflow: scroll !important;
}
.submit-button {
  margin-right: 45px;
  margin-bottom: 15px;
  float: right;
}
.form-80-percent-width {
  max-width: 77%;
  margin: 10px 0px;
      margin-left: auto;
    margin-right: 20px;
}
 label {
  padding-top: 6px;
  text-transform: capitalize;
  float: left !important;
  padding-left: 20px;
 }
 .gc-button {
  margin-top: 0px;
 }
 .gc-button:hover {
  color: white !important;
 }
  .gc-button:hover li{
  color: white !important;
 }
.gc-button li {
  text-align: center;
  color: #1997c6;
}
.plus {
  text-align: center;
  font-size: 75px;
}
.cross {
  margin: 5px;
  color: #E64759  !important;
}
.cross:hover {
  color: #E64759  !important;
  cursor: pointer;
}
.bullets ul {
  list-style-type: circle !important;
  padding-bottom: 0px !important;
  padding-top: 5px !important;
}
.bullets li {
  font-size: 16px;
  color: #B2B3B4 !important;
  margin-top: 0px !important;
  margin-left: 21px;
}
.bullets {
  height: auto !important;
}
.block {
  margin: 20px 15px;
  padding-top: 15px;
  padding-bottom: 18px;
  border: 1px solid #434857;
  border-radius: 6px;
}
li::marker{
  color: #1997c6;
}
.block ul{
  margin-bottom: 10px;
  text-align: left;
  border: 1px solid #434857;
  margin-right: 20px;
  border-radius: 6px;
  padding: 2px;
  vertical-align: center;
}
.block ul:hover {
  background-color: #434857;
}
.block ul li {
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}
.block ul li a {
  float: right !important;
  font-size: 12px !important;
  margin-top: 2px;
}
.block ul li a:hover {
  transform: scale(1.4);
}
.main-frame1 {
  overflow-x: hidden !important;
}
.fieldset {
  /* height: 520px !important;  */
}
.form-control {
  background-color: #191b20;
  color: #cfd2da;
  font-weight: 100;
}
select {
  padding-right: 10px;
}
.form-control:focus {
  background-color: white;
  color:#191b20;
}
.fieldset.edit {
  /* height: 645px !important;  */
}
.nav-button:hover {
  cursor: pointer;
  opacity: 0.8;
}
.make-main-button {
  background-color: #191B20;
  border-radius: 6px;
  width: 101%;
  margin-left: -1px;
  margin-bottom: -5px;
  margin-right: -1px;
  border: 1px solid #1997c6;
  color: #1997c6 !important; 
}
.make-main-button :hover {
  color: #1997c6 !important;
}
.notification {
  text-align: left;
  padding: 10px;
  background-color: #191B20;
  position: absolute;
  right: 23px;
  left: 15px;
  z-index: 1;
  border: 1px solid #1997c6;
  border-radius: 6px;
  font-weight: bold;
  font-size: 16px;

}
.notification-options {
  float: right;
}
.notification-options a {
  margin-right: 15px;
  color: #1997c6;
  cursor: pointer;
}
.notification-options a:hover {
}
</style>